<template>
  <div
    class="inline-flex self-start rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--muted)/0.45)] p-0.5"
    role="group"
    :aria-label="$t('legalDocuments.languageLabel')"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="min-w-11 h-11 px-2.5 rounded-md text-[11px] font-semibold transition-colors"
      :class="modelValue === option.value
        ? 'bg-[hsl(var(--card))] text-[hsl(var(--foreground))] shadow-sm'
        : 'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]'"
      :aria-pressed="modelValue === option.value"
      @click="$emit('update:modelValue', option.value)"
    >{{ option.label }}</button>
  </div>
</template>

<script setup lang="ts">
import type { LegalDocumentLocale } from "../content/legalDocuments";

defineProps<{ modelValue: LegalDocumentLocale }>();
defineEmits<{
  (event: "update:modelValue", locale: LegalDocumentLocale): void;
}>();

const options: { value: LegalDocumentLocale; label: string }[] = [
  { value: "kk", label: "ҚАЗ" },
  { value: "ru", label: "РУС" },
  { value: "en", label: "ENG" },
];
</script>
